// Passes files from one page to the next (home drop zone → tool, or a result →
// "use this file in another tool"). It is only a variable in this browser tab's
// memory: nothing is stored or sent anywhere, and a page reload clears it.

let pending: File[] = [];

export function handOffFiles(files: File[]) {
  pending = files;
}

/** The waiting files (safe to call more than once). */
export function peekHandedOffFiles(): File[] {
  return pending;
}

export function clearHandedOffFiles() {
  pending = [];
}
